import React from "react";
import NightAuditPaymentsSummaryPresenter from "./NightAuditPaymentsSummaryPresenter";
import NightAuditPaymentLogsPresenter from "./NightAuditPaymentLogsPresenter";

class NightAuditPaymentsPresenter extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return (
      <div>
        {/* <NightAuditPaymentsSummaryPresenter {...this.props} /> */}
        <NightAuditPaymentLogsPresenter {...this.props} />
      </div>
    );
  };

};

export default NightAuditPaymentsPresenter